module.exports = __webpack_public_path__ + "img/special-jury-award-bg.3188842f.jpg";